import React, { useState, useEffect } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import axiosInstance from "../../../../../services/api/API";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import Loader from "../../../../../customComponents/CustomLoader";

const EditDesignation = () => {

  const businessPartnerId = localStorage.getItem("business_partner_id")
  const [loading, setLoading] = useState(false);
  const [ userTypedd, setUserTypedd ] = useState([])
  const userType = localStorage.getItem("UserType")
  const [Required,setRequired] = useState(false)
console.log("Required>>>",Required);
const location = useLocation();
  const { data } = location.state || {};


  const [formData, setFormData] = useState({});
  const [showParentDesignation, setShowParentDesignation] = useState(false);
  const [designationInputs, setDesignationInputs] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");


  const DesignationInputsTemplate = [
    // ...(userType === "superadmin"
    //   ? [
    //       {
    //         name: "business_partner_id",
    //         label: "Business Partner",
    //         type: "dropdown",
    //         required: true,
    //         options: [],
    //         gridClass: "col-lg-4",
           
    //       },
    //     ]
    //   : []),
    {
      name: "designationlevel",
      label: "Role",
      type: "dropdown",
      required: true,
      gridClass: "col-lg-4",
      options: designationInputs,
    },
    {
      name: "designationName",
      label: "Designation Name",
      type: "text",
      placeholder:"Enter Designation Name",
      required: true,
      gridClass: "col-lg-4",
       validation: { required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
      maxLength:20
     },
    },
    {
      name: "description",
      label: "Description",
      placeholder:"Enter Designation Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
     
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
      validation: {
        required: true,
        message: "Status is required",
      },
      gridClass: "col-lg-4",
    },
    // {
    //   name: "parentDesignation",
    //   label: "Parent Designation",
    //   type: "dropdown",
    //   gridClass: "col-lg-4",
    //   isVisible: false, 
    //   required:Required,
    //   validation:{required:true},
    //   options: [],
    // },
  ];

  useEffect(() => {
    fetchRoleDetails();
  }, []);

  const fetchRoleDetails = async () => {
    try {
      setLoading(true)
      const response = await axiosInstance.get(`designation/edit/${data.designation_id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      const fetchedData = response.data.data;
      console.log("fetchedData",fetchedData);
      setFormData({
        designationlevel:fetchedData.role_id,
        designationName: fetchedData.designation_name,
        description: fetchedData.designation_desc,
        status: fetchedData.status === 1 ? "Active" : "Inactive",
      });
    } catch (error) {
      console.error("Error fetching role details:", error);
    }
    finally{
      setLoading(false)
    }
  };

   useEffect(() => {
    fetchRoleDropdown()
  },[])

  const fetchRoleDropdown = async () => {
    try {

      const payload = {
        // business_partner_id: 1  ,
      }

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        "/role/ddlrole",payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const roleOptions = response.data.data.data.map(user => ({
        label: user.NAME,
        value: user.ID,
      }));
      setDesignationInputs(roleOptions)

    } catch (error) {
      console.error("Error fetching designation levels:", error);
    }
  };

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
  
    DesignationInputsTemplate.forEach((field) => {
      if (field.required && !formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      } else if (field.validation && field.validation.pattern && !field.validation.pattern.test(data[field.name])) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    // Show confirmation alert before proceeding
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this designation?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
  
          const payload = {
            hierarchy_level: formData.designationlevel,
            //  parent_designation_id:formData.designationlevel>1? formData.parentDesignation:null,
            designation_name: formData.designationName,
            designation_desc: formData.description,
            status: formData.status === "Active" ? 1 : 0,
          };
  
          if (userType === "superadmin") {
            payload.business_partner_id = data.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }
  
          await axiosInstance.patch(
            `/designation/update/${data.designation_id}`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              }
            }
          );
  
          // Success alert after updating the designation
          Swal.fire({
            title: "Success",
            text: "Designation updated successfully.",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            navigate(ROUTES_NAVIGATION.DESIGNATIONLIST); // Navigate after user clicks OK
          });
  
        } catch (error) {
          const errorMessage = error.response?.data?.message || "Failed to update designation. Please try again.";
          
          // Error alert if the API call fails
          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
  
          console.error("Error updating designation:", error);
        } finally {
          setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // User cancelled the action
        Swal.fire({
          title: "Cancelled",
          text: "Designation update cancelled.",
          icon: "info",
          confirmButtonText: "OK",
        });
      }
    });
  };
  

  useEffect(() => {
    userTypedropdown()
  },[])

  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      })

      const userTypeOptions = response.data.data.data.map(user => ({
        label:user.bp_name,
      value: user.onboard_id,
      }));
      console.log("userTypeOptions>>", userTypeOptions);
      

      // setDesignationInputs((prevInputs) =>
      //   prevInputs.map((input) =>
      //     input.name === "business_partner_id" ? { ...input, options: userTypeOptions, isVisible: true } : input
      //   )
      // );


    }catch(error) {
      console.log(error)
    }
  }

  return (
    <>
      <div>
    {loading ? (
      <Loader />
    ) : (
      <><div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
              <img src={backicon} alt="back" />
              <span className="backbtntitle">Edit Designation</span>
            </div><div className="form-container">
                <span className="cust-det-title mt-2 mb-2">
                  Please Edit Designation Details
                </span>
                <DynamicForm
                  formConfig={DesignationInputsTemplate}
                  formData={formData}
                  setFormData={setFormData}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                  onSubmit={handleFormSubmit}
                  // showParentDesignation={showParentDesignation} 
                  />
              </div><div className="btncontainer mt-3">
                <button
                  onClick={() => {
                    handleFormSubmit(formData);
                  } }
                  className="submit-btn"
                >
                  Submit
                </button>
              </div></>
    )}
    </div>
    </>
  );
};

export default EditDesignation;
